import { render, staticRenderFns } from "./Goals.vue?vue&type=template&id=3f8096c3&scoped=true&"
var script = {}
import style0 from "./Goals.vue?vue&type=style&index=0&id=3f8096c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8096c3",
  null
  
)

export default component.exports
import {QCard,QCardSection,QImg} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QImg}, component.options.components || {})
